import * as React from 'react';

import { AreaPartsContainer } from './components/AreaParts';
import { MultiPostingContainer } from './components/MultiPosting';
import { Layout } from '../ServicePickerWidget/Layout';

export const MessageWrapper = () => {
  return (
    <div data-testid="messages">
      <Layout>
        <AreaPartsContainer />
        <MultiPostingContainer />
      </Layout>
    </div>
  );
};
